// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__-YknB","errorLogs":"styles_errorLogs__2UUTz"};